/* eslint-disable no-lonely-if */
const burgerMenuToggle = document.querySelector(".burger-menu-toggle");
const mobileMenu = document.querySelector(".mobile-menu");
const dropdownToggles = document.querySelectorAll(".mobile-dropdown-icon");
const burgerIcon = document.querySelector(".burger-icon");
const closeIcon = document.querySelector(".close-icon");

function toggleIcons() {
  burgerIcon.style.display =
    burgerIcon.style.display === "none" ? "block" : "none";
  closeIcon.style.display =
    closeIcon.style.display === "none" ? "block" : "none";
}

function toggleScrollLock() {
  if (mobileMenu.classList.contains("active")) {
    document.body.classList.add("no-scroll");
  } else {
    document.body.classList.remove("no-scroll");
  }
}

burgerMenuToggle.addEventListener("click", () => {
  mobileMenu.classList.toggle("active");
  toggleIcons();
  toggleScrollLock();

  if (mobileMenu.classList.contains("active")) {
    if (window.$crisp) {
      window.$crisp.push(["do", "chat:hide"]);
    }
  } else {
    if (window.$crisp) {
      window.$crisp.push(["do", "chat:show"]);
    }
  }
});

dropdownToggles.forEach((dropdownToggle) => {
  dropdownToggle.addEventListener("click", (e) => {
    e.stopPropagation();

    const parentDropdown = dropdownToggle.closest(".mobile-dropdown");
    const dropdownMenu = parentDropdown.querySelector(
      ".mobile-navigation-list-dropdown"
    );

    parentDropdown.classList.toggle("active");
    dropdownMenu.classList.toggle("active");

    const downIcon = dropdownToggle.querySelector(".down-icon");
    const aboveIcon = dropdownToggle.querySelector(".above-icon");

    if (dropdownMenu.classList.contains("active")) {
      if (downIcon) downIcon.style.display = "none";
      if (aboveIcon) aboveIcon.style.display = "block";
    } else {
      if (downIcon) downIcon.style.display = "block";
      if (aboveIcon) aboveIcon.style.display = "none";
    }

    dropdownToggles.forEach((otherToggle) => {
      const otherParentDropdown = otherToggle.closest(".mobile-dropdown");
      const otherDropdownMenu = otherParentDropdown.querySelector(
        ".mobile-navigation-list-dropdown"
      );
      if (otherToggle !== dropdownToggle && otherDropdownMenu.classList.contains("active")) {
        otherParentDropdown.classList.remove("active");
        otherDropdownMenu.classList.remove("active");

        const otherDownIcon = otherToggle.querySelector(".down-icon");
        const otherAboveIcon = otherToggle.querySelector(".above-icon");
        if (otherDownIcon) otherDownIcon.style.display = "block";
        if (otherAboveIcon) otherAboveIcon.style.display = "none";
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  document.addEventListener("click", function (event) {
    if (!mobileMenu.contains(event.target) && mobileMenu.classList.contains("active")) {
      mobileMenu.classList.remove("active");
      toggleIcons();
      toggleScrollLock();

      if (window.$crisp) {
        window.$crisp.push(["do", "chat:show"]);
      }

      dropdownToggles.forEach((dropdownToggle) => {
        const parentDropdown = dropdownToggle.closest(".mobile-dropdown");
        const dropdownMenu = parentDropdown.querySelector(
          ".mobile-navigation-list-dropdown"
        );
        if (dropdownMenu.classList.contains("active")) {
          parentDropdown.classList.remove("active");
          dropdownMenu.classList.remove("active");
          const downIcon = dropdownToggle.querySelector(".down-icon");
          const aboveIcon = dropdownToggle.querySelector(".above-icon");
          if (downIcon) downIcon.style.display = "block";
          if (aboveIcon) aboveIcon.style.display = "none";
        }
      });
    }
  });
});
